// extracted by mini-css-extract-plugin
module.exports = {"author-container":"_3qqhy","author-box":"_3esNh","image-wrapper":"_23GIo","image":"_2cxsA","author-details":"_1Br88","name":"_1lHjM","bio":"IeRON","twitter-handle":"_2v1_Q"};